import KngScormPlayer from './src/main';

/* istanbul ignore next */
KngScormPlayer.install = function(Vue) {
  Vue.component(KngScormPlayer.name, KngScormPlayer);
};

export default KngScormPlayer;
